import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=bf0e0ac2&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=js"
export * from "./TagsView.vue?vue&type=script&lang=js"
import style0 from "./TagsView.vue?vue&type=style&index=0&id=bf0e0ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0e0ac2",
  null
  
)

export default component.exports